'use client';

import dynamic from 'next/dynamic';

const ApplicationError = dynamic(() => import('../pages/_appError.page'));

/**
 * Handles application error .
 */
export const Error = (data: Record<string, Error & { digest?: string }>) => {
  const { digest } = data.error;

  return <ApplicationError scheme="light" errorCode={digest} />;
};

export default Error;
